export const handlePageNumbers = store => {
  store.subscribe(mutation => {
    if (mutation.type.split('/')[0] === 'pageNumber') {
      store.commit('queryParams/setPage', store.getters['pageNumber/getCurrent'])
    }
  })
}
